export default {
    '/': {
        name: '首页',
        path: '/',
        fullPath: '/'
    }
    // '/cart': {
    //     name: '购物车',
    //     path: '/cart',
    //     fullPath: ''
    // },
    // '/detail': {
    //     name: '宠物详情',
    //     path: '/detail',
    //     fullPath: ''
    // },
    // '/order': {
    //     name: '下单',
    //     path: '/order',
    //     fullPath: ''
    // },
    // '/my': {
    //     name: '我的',
    //     path: '/my',
    //     fullPath: ''
    // }
}
